namespace Solovis.Reports.Parameters {

    interface LiquidityModelOption {
        id: number;
        label: string;
    }

    export class LiquidityModelParameterControl extends Solovis.UI.BaseControl {

        public initialParameterValue: LiquidityModelOption;
        public currentLiquidityModel: LiquidityModelOption;

        public selectedLabel: JQuery;
        public selectLink: JQuery;

        private _portalServices: Solovis.Portal.IPortalServices;
        private _models: LiquidityModelOption[];

        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;
            this.initialParameterValue = options.initialValue ?? null;
            this.currentLiquidityModel = this.initialParameterValue;
        }

        public async doInitAsync() {
            this._models = await this._loadLiquidityModelsAsync();
            this.notifyInitComplete();
        }

        private _loadLiquidityModelsAsync(): Promise<LiquidityModelOption[]> {
            return new Promise((resolve) => {
                (Solovis as any).Reports.ReportDataLoader.loadDataSetAsync(
                    "/Solovis/Liquidity/LiquidityModelList",
                    {},
                    (response, success) => {
                        if (!success) {
                            resolve([]);
                            return;
                        }
                        const models = response?.result?.dataSet?.models ?? [];
                        const mapped: LiquidityModelOption[] = models.map((m: any) => ({
                            id: m.id,
                            label: m.label,
                        }));
                        mapped.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
                        resolve(mapped);
                    });
            });
        }

        public doRender() {
            const self = this;

            this.selectedLabel = $("<span>").appendTo(this.container);
            this.selectLink = $("<a>")
                .html("<span class='fa fa-pencil'></span>")
                .appendTo(this.container);

            Solovis.UI.DomHelper.focusableClick(this.selectLink, () => {
                self._openSelectorDialog((selected) => {
                    self._setCurrentLiquidityModel(selected);
                    self.notifyParameterValueChanged();
                });
            });

            if (this.currentLiquidityModel) {
                this._setCurrentLiquidityModel(this.currentLiquidityModel);
            }
        }

        private _setCurrentLiquidityModel(model: LiquidityModelOption) {
            this.currentLiquidityModel = model;
            if (model) {
                this.selectedLabel.text(model.label + " ");
            }
            else {
                this.selectedLabel.text("");
            }
        }

        private _openSelectorDialog(selectionCallback: (model: LiquidityModelOption) => void) {
            Solovis.UI.Dialogs.StringFilterListDialog.showDialog({
                title: "Select Liquidity Model",
                showClearButton: true,
                selectCallback: (selectedItem) => {
                    selectionCallback(selectedItem);
                },
                stringFilterListControlOptions: {
                    listItems: this._models ?? [],
                    itemDivGenerator: (itemHolder, filterOptions) => {
                        return $("<div>").text(itemHolder.item.label);
                    },
                },
            });
        }

        public setParameterValue(newValue: LiquidityModelOption) {
            this._setCurrentLiquidityModel(newValue);
        }

        public static getLabel(value): string | undefined {
            return value?.label;
        }

        public getParameterValue(): LiquidityModelOption {
            if (!this.currentLiquidityModel) {
                return null;
            }
            return { id: this.currentLiquidityModel.id, label: this.currentLiquidityModel.label };
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }

        public focus() {
            $(this.selectLink).focus();
        }
    }

}
